// TableViewAdd.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './TableViewAdd.css';

// Icons
import Icon from 'svg/Icon';

/**
 * TableViewAdd
 *
 * @returns {ReactNode} The rendered component.
 */
const TableViewAdd = React.memo(({ onClick }) => {

    // ----- CONTEXT ----- //

    const { theme } = useTheme();

    // ----- STATE ----- //

    const [hovered, setHovered] = useState(false);

    // ----- HANDLERS ----- //

    /**
 * Handles key down.
 *
 * @param {*} event
 */

    const handleKeyDown = (event) => {
        if (!onClick) return;
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onClick();
        }
    };

    // ----- RENDER ----- //

    return (
        <div
          className="table-view-add-container"
          style={{
                backgroundColor: hovered ? theme.backgroundHover : undefined,
            }}
          role="button"
          tabIndex={0}
          title="Add New Row"
          onClick={onClick}
          onKeyDown={handleKeyDown}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
            <Icon
              iconKey="add"
              color={hovered ? theme.foreground : theme.foregroundMuted}
              width={20}
              height={20}
            />
        </div>
    );
});

// Dev Tools
TableViewAdd.displayName = 'TableViewAdd';

export default TableViewAdd;
